import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  Fragment,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  searchCustomerList,
  infiniteSearchCustomerList,
  initCustomerList,
} from '@store/actions/customerAction';
import {
  SEARCH_DEBOUNCE_TIME,
  ADULT_AGE,
  CHILD_AGE,
} from '@common/constants';
import SatInput from '@components/common/satUI/SatInput';
import { RegisterCorporate } from '@container/customer';

// 검색 Debouncing을 위한 변수들
let searchDebouncingTimer = null;

const SearchCustomer = props => {
  const {
    title,
    onSelectCustomer,
    custKind, // 개인(P) / 법인(C) 여부
    excludeCustNo = [],
    isRelation = false, // 가족구성원
    isAdult = false, // 가족구성원 중 성인만
    isChild = false, // 검색 시, 미성년자만 노출
    isOnlyAdult = false, // 검색 시, 성인만 노출 (isAdult 변수가 이미 있어서 isOnlyAdult로 설정)
    isDefaultRelation = false, // 검색 시, 기본값으로 가족구성원 노출
  } = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const searchInputRef = useRef();

  const { alert } = $hooks.useModal();
  const { customerList, customerRelationList } = useSelector(
    state => state.customerReducer,
  );
  const { isLoading } = useSelector(state => state.commonReducer);

  const [searchVal, setSearchVal] = useState('');
  const [searchView, setSearchView] = useState('customer');
  const [isScroll, setIsScroll] = useState(false);
  const [isShowCorporateModal, setIsShowCorporateModal] = useState(false);

  // 검색 조건 미포함 시, API 서버 에러로 인해 기본값 추가
  const [searchType] = useState('N');

  // searchVal 의 Debouncing 적용을 위한 Value
  const [searchDebounceVal, setSearchDebounceVal] = useState(searchVal);

  // 키보드 타이핑마다 검색 되는 것을 방지하기 위한 Debouncing 처리
  useEffect(() => {
    clearTimeout(searchDebouncingTimer);

    searchDebouncingTimer = setTimeout(() => {
      // 검색어가 기존과 동일할 경우 다시 검색 하지 않고,
      // 검색어가 다를 경우에만 검색 요청
      if (searchDebounceVal !== searchVal) setSearchDebounceVal(searchVal);
      searchDebouncingTimer = null;
    }, SEARCH_DEBOUNCE_TIME);
  }, [searchVal]);

  useEffect(() => {
    searchInputRef.current.onFocus();
    // if (customerList.length === 0) {
    //   if (isRelation) setSearchView('relation');
    //   else if (isCorporation) setSearchView('corporation');
    //   else if (isChild) setSearchView('child');
    //   else dispatch(searchCustomerList({ searchValue: '', init: true }));
    // }

    return () => dispatch(initCustomerList());
  }, []);

  // useEffect(() => {
  //   // 검색어가 입력된 경우, 고객 검색 액션 Dispatch
  //   if (searchVal !== '') {
  //     setIsScroll(true);
  //     setSearchView('customer');
  //     dispatch(
  //       searchCustomerList({
  //         searchType: searchType,
  //         searchValue: searchVal,
  //         init: false,
  //         fromAge: isOnlyAdult ? ADULT_AGE : undefined,
  //         toAge: isChild ? CHILD_AGE : undefined,
  //       }),
  //     );
  //   }

  //   // 검색어가 지워진 경우, 최근 등록 고객 액션 Dispatch
  //   else {
  //     dispatch(
  //       searchCustomerList({
  //         searchValue: '',
  //         searchType: searchType,
  //         fromAge: isOnlyAdult ? ADULT_AGE : undefined,
  //         toAge: isChild ? CHILD_AGE : undefined,
  //         init: true,
  //       }),
  //     );
  //     if (isRelation) setSearchView('relation');
  //   }
  // }, [searchDebounceVal]);

  const handleInput = value => {
    setSearchVal(value);
  };

  const searchCustomerHandle = () => {
    searchInputRef.current.onFocus();
    if (searchVal !== '') {
      setIsScroll(true);
      setSearchView('customer');
      dispatch(
        searchCustomerList({
          searchType: searchType,
          searchValue: searchVal,
          init: false,
          fromAge: isOnlyAdult ? ADULT_AGE : undefined,
          toAge: isChild ? CHILD_AGE : undefined,
          custTpCd: $utils.getCustTpCd(custKind),
        }),
      );
      return () => dispatch(initCustomerList());
    }
  };

  const handleMoveRegister = () => {
    history.push({
      pathname: '/customer/register-individual',
      state: { customerName: searchVal },
    });
  };

  const showCorporateModal = () => {
    setIsShowCorporateModal(true);
  };

  /* @NOTE: 리스트의 스크롤이 안생기는 경우, 무한 스크롤 안됨으로 해당 사용 안함 */
  // const onScroll = () => {
  //   const list = document.getElementById('customerList');
  //   if (
  //     list.scrollTop + list.clientHeight >= list.scrollHeight - 1 &&
  //     !isLoading
  //   ) {
  //     if (isScroll) {
  //       dispatch(
  //         infiniteSearchCustomerList({
  //           searchValue: searchVal,
  //           searchType: searchType,
  //           fromAge: isOnlyAdult ? ADULT_AGE : undefined,
  //           toAge: isChild ? CHILD_AGE : undefined,
  //         }),
  //       );
  //     }
  //   }
  // };

  const handleSearchMore = entries => {
    const target = entries[0];
    const isTargetInScreen = target.isIntersecting;
    if (!searchDebounceVal || !isTargetInScreen) return;

    dispatch(
      infiniteSearchCustomerList({
        searchValue: searchVal,
        searchType: searchType,
        fromAge: isOnlyAdult ? ADULT_AGE : undefined,
        toAge: isChild ? CHILD_AGE : undefined,
        custTpCd: $utils.getCustTpCd(custKind),
      }),
    );
  };

  const setInfiniteScroll = () => {
    const observer = new IntersectionObserver(handleSearchMore, {
      root: null,
      threshold: 0,
    });

    const infiniteScrollRef = document.querySelector('#infiniteScrollRef');
    if (infiniteScrollRef) observer.observe(infiniteScrollRef);
  };

  useEffect(setInfiniteScroll, [customerList, customerRelationList]);

  const handleSelectCustomer = useCallback(customer => {
    if (isRelation) {
      if (isAdult && !customer.adult) {
        const message = '미성년자는 지정대리청구인으로 지정할 수 없어요.';
        return alert({ message });
        // return dispatch(showModal({ visible: true, msg: message }));
      }
    }

    onSelectCustomer(customer);
  }, []);

  const SearchCustomerList = ({
    searchView,
    list = [],
    excludeList,
    onSelect,
  }) => {
    const getMatchedText = useCallback(str => {
      if (str === searchVal) {
        return <em>{searchVal}</em>;
      } else {
        const strArr = str.split(searchVal);
        if (strArr.find(strText => strText === '')) {
          return strArr.map(strText => {
            return strText === '' ? <em>{searchVal}</em> : strText;
          });
        } else {
          return strArr.map((strText, index) => (
            <Fragment key={index}>
              {index === 0 ? (
                strText
              ) : (
                <>
                  <em>{searchVal}</em>
                  {strText}
                </>
              )}
            </Fragment>
          ));
        }
      }
    }, []);

    return !isLoading && list.length === 0 && searchVal !== '' ? (
      <li
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span className="user-state" style={{ marginLeft: 'unset' }}>
          검색 결과가 없습니다.
        </span>
      </li>
    ) : (
      list
        .filter(customer => !excludeList.includes(customer.custNo))
        .map((customer, index) => {
          return (
            <li
              id={list.length - 1 === index ? 'infiniteScrollRef' : null}
              key={index}
              onClick={() => onSelect(customer)}
            >
              <span className="user-info">
                {searchView === 'customer' ? (
                  getMatchedText(customer.name)
                ) : (
                  <em className="c-black">{customer.name}</em>
                )}
                {customer.custKind === 'C'
                  ? ` (${customer.rsdn ? `${customer.rsdn}, ` : ''}법인)`
                  : ` (${customer.rsdn.substr(0, 6)}, ${customer.genderLabel})`}
              </span>
              {searchView === 'customer' && (
                <span className="user-state">{customer.policyType}</span>
              )}
            </li>
          );
        })
    );
  };

  return (
    <Fragment>
      <header className="modal-header">
        <h3 className="layer-tit2">{title}</h3>
      </header>
      <div className="cont">
        <SatInput
          ref={searchInputRef}
          value={searchVal}
          type="search"
          placeholder="이름으로 고객을 검색하세요."
          onChange={handleInput}
          //onBlur={searchCustomerHandle}
          onPressEnter={searchCustomerHandle}
        />
      </div>

      <div className="search-wrap customer-pop">
        {searchView === 'relation' && <p className="label">가족관계</p>}
        {searchView === 'corporation' && <p className="label">법인구성원</p>}
        {searchView === 'child' && <p className="label">자녀</p>}

        <ul
          className="list"
          id="customerList"
          style={{
            height: '100%',
            minHeight: '25vh',
            // maxHeight: '54vh',
            overflowY: searchView === 'customer' ? 'scroll' : 'hidden',
            overflowX: 'hidden',
          }}
          /* @NOTE: 리스트의 스크롤이 안생기는 경우, 무한 스크롤 안됨으로 해당 사용 안함 */
          // onScroll={onScroll}
        >
          <SearchCustomerList
            searchView={searchView}
            list={
              searchView === 'customer'
                ? isDefaultRelation && !customerList?.length && !searchVal
                  ? customerRelationList
                  : customerList
                : customerRelationList
            }
            excludeList={excludeCustNo}
            onSelect={handleSelectCustomer}
          />
        </ul>

        {!isRelation && !isChild && (
          <div className="wrap-not-search">
            <span className="txt">고객이 검색되지 않으세요?</span>
            <div className="side-r">
              <span onClick={showCorporateModal} className="btn-view2">
                법인고객등록
              </span>
              <span onClick={handleMoveRegister} className="btn-view2">
                개인고객등록
              </span>
            </div>
          </div>
        )}
      </div>

      <RegisterCorporate
        isModal
        isOpen={isShowCorporateModal}
        onClose={() => setIsShowCorporateModal(false)}
      />
    </Fragment>
  );
};

export default SearchCustomer;
